import {FileUploadContext} from "./navigation-types";

export const MENU_ITEM_IMAGE_CONTEXT: FileUploadContext = "menuitemimg";
export const STORAGE_PATH_DELIMITER = "/";

export class MenuItemImageStoragePath {
    tenantKey: string;
    menuKey: string;
    fileName: string;

    constructor(tenantKey: string, menuKey: string, fileName: string) {
        this.tenantKey = tenantKey;
        this.menuKey = menuKey;
        this.fileName = fileName;
    }

    getStoragePath() {
        return this.tenantKey + STORAGE_PATH_DELIMITER + this.menuKey + STORAGE_PATH_DELIMITER + MENU_ITEM_IMAGE_CONTEXT + STORAGE_PATH_DELIMITER + this.fileName;
    }
}
